// src/redux/store.js
import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers";
import { supplierFormPersistenceMiddleware, loadSupplierFormState } from "./middleware/supplierFormPersistence";

// Load initial state from localStorage if available
const preloadedState = {
  supplierForm: loadSupplierFormState() || undefined
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  preloadedState,
  composeEnhancers(applyMiddleware(supplierFormPersistenceMiddleware))
);

export default store;
